import script from "./MGNavPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGNavPanel.vue?vue&type=script&setup=true&lang=ts"

import "./MGNavPanel.vue?vue&type=style&index=0&id=45555024&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45555024"]])

export default __exports__